import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { NotificationBanner } from 'src/app/interfaces/banner/notification-banner';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NotificationBannerComponent {
  constructor() {}

  @Input() notificationBanner!: NotificationBanner;
  @Output() bannerClose: EventEmitter<NotificationBanner> =
    new EventEmitter<NotificationBanner>();

  onClose() {
    this.bannerClose.emit(this.notificationBanner);
  }

  ngOnInit(): void {}
}
